(ns frontend.view.components.form.components.form-text
  (:require
   [clojure.string :as string]
   [frontend.bootstrap.components :as rbs]
   [frontend.utils :as fu]
   [frontend.view.components.form.components.form-cancel-button :as cancel-button]
   [frontend.view.components.form.components.form-label :as form-label]
   [goog.string :as gstring]
   [reagent.core :as r]))

(defn- render-input
  [placeholder control-id raw-input value validate! has-focus set-edit! on-change! on-key-down!
   read-only? password?]
  (fn [placeholder control-id raw-input value validate! has-focus set-edit! on-change! on-key-down!
       read-only? password? prevent-autocomplete?]
    [:input
     (merge {:placeholder (or placeholder "")
             :type        (if password? "password" "text")
             :id          control-id
             :class-name  (str "form-control")
             :value       (str (if (nil? @raw-input) value @raw-input))
             :on-change   (fn [e]
                            (let [input (-> e
                                            .-target
                                            .-value)]
                              (reset! raw-input input)
                              (when validate! (validate! @raw-input))))
             :on-focus    #(do (reset! has-focus true)
                               (set-edit! true))
             :on-blur     #(do (reset! has-focus false)
                               (on-change! (-> %
                                               .-target
                                               .-value))
                               (when validate!
                                 (validate! (-> %
                                                .-target
                                                .-value))))
             :on-key-down on-key-down!}
            (when read-only?
              {:disabled true})
            (when prevent-autocomplete?
              {:auto-complete "new-password"}))]))

(defn view
  [{:keys [value]}]
  (let [raw-input (r/atom value)
        has-focus (r/atom false)]
    (fn
      [{:keys [entity field intelligence-value label type size value placeholder wrapper control-id
               trim-on-save?
               empty-on-submit? info
               set-edit! password? prevent-autocomplete?
               on-change! on-submit! on-cancel!
               validate! read-only? intelligence-value]
        :as   view-args}]
      (let [r-value (if (not (empty? (string/trim (str value))))
                      value
                      intelligence-value)
            tooltip (r/as-element [rbs/Tooltip
                                   {:id        "tooltip"
                                    :placement "top"
                                    :class     "in"}
                                   info])
            on-cancel! (fn [e]
                         (reset! raw-input nil)
                         (on-cancel! e))
            on-submit! (fn [e]
                         (when trim-on-save?
                           (let [t-r (gstring/trim (str @raw-input))]
                             (on-change! t-r)
                             (reset! raw-input t-r)))
                         (on-submit! e)
                         (when empty-on-submit?
                           (reset! raw-input nil)))
            on-key-down! (fn [e]
                           (let [key (.-keyCode e)]
                             (when (= key 13)
                               (-> e
                                   .-target
                                   .blur))                  ;; Enter = blur -> save
                             (when (= key 27)               ;; Esc = cancel
                               (on-cancel! e)
                               (-> e
                                   .-target
                                   .blur))))]
        [rbs/Form
         {:on-submit (fn [e]
                       (on-change! @raw-input)
                       (if (and @raw-input
                                (not= @raw-input value))
                         (on-submit! e)
                         (on-cancel! e)))
          :on-blur   (fn [e]
                       (let [targetType (-> e
                                            .-target
                                            .-nodeName)
                             targetValue (-> e
                                             .-target
                                             .-value)]
                         (if (and (= targetType "INPUT")
                                  @raw-input
                                  (not= @raw-input value)
                                  (not= targetValue value))
                           (do
                             (on-submit! e))
                           (on-cancel! e))))}
         [rbs/FormGroup
          {:control-id control-id
           :size       size
           :class-name (fu/cs wrapper "form__text")}
          (when (and label (not-empty label))
            [form-label/view
             (merge view-args
                    {:intelligence-value intelligence-value})])
          [rbs/InputGroup {:style {:width "100%"}}
           [render-input placeholder control-id raw-input r-value validate! has-focus set-edit!
            on-change! on-key-down! read-only? password? prevent-autocomplete?]
           (when @has-focus
             [cancel-button/view on-cancel!])]]]))))
